export const home = {
  // Hero Section
  title: 'MakanTak',
  tagline: 'Earn rewards by sharing. Save on every meal.',
  subtitle: 'The viral restaurant discount platform.',
  getStarted: 'Join now',
  login: 'Login',
  demo: 'Demo',
  
  // Features
  feature1Title: '5% Guaranteed Discount',
  feature1Desc: 'Get an instant 5% discount on your first visit at any participating restaurant. No strings attached.',
  feature1Badge: 'First visit bonus',
  
  feature2Title: 'Share & Earn',
  feature2Desc: 'Share your unique code with friends. Earn 1% of their bill as virtual currency every time they dine.',
  feature2Badge: '3-level rewards system',
  
  feature3Title: 'Redeem Rewards',
  feature3Desc: 'Use your earned virtual currency to pay for your meals. Redeem up to 20% of your bill.',
  feature3Badge: 'Max 20% redemption',
  
  // Merchant CTA
  merchantTitle: 'Own a Restaurant?',
  merchantSubtitle: 'Join MakanTak and turn your customers into brand ambassadors. Pay only for results with our viral referral system.',
  merchantPoint1: 'Max 8% marketing cost - only pay when customers dine',
  merchantPoint2: 'Build your own customer referral network',
  merchantPoint3: 'Track ROI with real-time analytics dashboard',
  merchantCTA: 'Partner with us',
  
  // About Section
  aboutTitle: 'Why MakanTak?',
  aboutSubtitle: 'We\'re revolutionizing how Malaysian restaurants grow their business through viral word-of-mouth marketing.',
  
  aboutCard1Title: 'Community-Driven',
  aboutCard1Desc: 'Built for Malaysian local restaurants and their loyal customers. We believe in growing together through authentic referrals.',
  
  aboutCard2Title: 'Performance-Based',
  aboutCard2Desc: 'No upfront costs. Restaurants only pay when customers actually dine. Transparent, measurable, and fair for everyone.',
  
  aboutCard3Title: 'Secure & Compliant',
  aboutCard3Desc: 'PDPA-compliant with robust security measures. Your data is protected, and your privacy is our priority.',
  
  // Footer
  footerTagline: 'Share the savings, grow the community.',
  footerDesc: 'The viral restaurant discount platform for Malaysian local restaurants.',
  forCustomers: 'For Customers',
  forRestaurants: 'For Restaurants',
  company: 'Company',
  demoLink: 'Demo Dashboard',
  faqLink: 'FAQs',
  merchantEnquiry: 'Merchant Enquiry',
  aboutUs: 'About Us',
  contact: 'Contact',
  privacy: 'Privacy Policy',
  terms: 'Terms of Service',
  copyright: '© 2026 MakanTak. All rights reserved.',
  followUs: 'Follow us on X',
};
